import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
import { ToggleVariantType } from '../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [ToggleVariantType.REGULAR]: {
            container: {
                display: 'flex',
                width: 'fit-content',
                align_items: 'center',
                gap: FOUNDATIONS.spacing_100,
                text_align: 'center',
                cursor: 'pointer',
            },
            legend: {
                font_variant: TextVariantType.FONT_PARAGRAPH_400,
                color: FOUNDATIONS.color_neutral_font_50,
                font_weight: FONT_WEIGHT.font_weight_600,
                disabled: {
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                    font_weight: FONT_WEIGHT.font_weight_600,
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map